// How many times the embedded LAYI may heal itself (re-login + reload) before it gives up and shows
// the retry button. A plain counter between manual retries, with one twist: a session that stayed
// healthy for `resetAfterMs` restores the full budget first. The LAYI cookie lasts a day, so a page
// left open loses it once a day and heals through `/login`; without the window, isolated recoveries
// on different days would add up to "refused". A cookie that never works also shows the root
// document for an instant before Chainlit redirects to `/login`, hence the MINIMUM healthy time — a
// reset on any healthy sighting would unbound the loop. Same rule as the mobile app's LAYI tab.
export const createRecoveryBudget = ({ maxAttempts, resetAfterMs, now = Date.now }) => {
  let used = 0
  let healthySince = null

  return {
    // The frame shows a LAYI document that is not the login page (first sighting since the last recovery).
    markHealthy: () => {
      if (healthySince === null) healthySince = now()
    },
    // Consumes one automatic recovery; false once the budget is spent.
    tryConsume: () => {
      if (healthySince !== null && now() - healthySince >= resetAfterMs) used = 0
      healthySince = null
      if (used >= maxAttempts) return false
      used += 1
      return true
    },
    // Manual retry or identity change (locale): start over.
    reset: () => {
      used = 0
      healthySince = null
    }
  }
}
